<template>
  <div>
    <base-card>
      <template v-slot:header>
        <base-card-heading>Details</base-card-heading>
      </template>
      <div class="row">
        <div class="col-sm-6">
          <base-field label="Project Type">
            <base-select v-model="value.type" placeholder="type" :readonly="readonly" source="projectTypes" />
          </base-field>
        </div>
        <div class="col-sm-6">
          <base-field label="Title Number(s)" tooltip="Separate each number with a comma (,).">
            <base-input v-model="value.titleNumbers" placeholder="title number(s)" :readonly="readonly" />
          </base-field>
        </div>
        <div class="col-md-6">
          <base-field addon-left-icon="calendar-alt" label="Purchase/Option Date">
            <base-input v-model="value.purchaseDate" datepicker placeholder="purchase date" :readonly="readonly" />
          </base-field>
        </div>
        <div class="col-md-6">
          <base-field addon-right="months" label="Projected Build Period">
            <base-input v-model="value.projectedBuildPeriod" placeholder="projected build period" :readonly="readonly" type="number" />
          </base-field>
        </div>
        <div class="col-md-6">
          <base-field addon-left-icon="calendar-alt" label="Projected Start Date">
            <base-input v-model="value.projectedStartDate" datepicker placeholder="projected start date" :readonly="readonly" />
          </base-field>
        </div>
        <div class="col-md-6">
          <base-field addon-left-icon="calendar-alt" label="Projected Completion Date">
            <base-input v-model="value.projectedCompletionDate" datepicker placeholder="projected completion date" :readonly="readonly" />
          </base-field>
        </div>
        <div class="col-sm-6">
          <base-field addon-right="units" label="Total Units">
            <base-input v-model="value.units" placeholder="units" :readonly="readonly" type="number" />
          </base-field>
        </div>
        <div class="col-sm-6">
          <base-field addon-right="sqm" label="Total Floor Area">
            <base-input v-model="value.totalFloorArea" placeholder="total floor area" :readonly="readonly" type="number" />
          </base-field>
        </div>
      </div>
    </base-card>
    <base-card>
      <template v-slot:header>
        <base-card-heading>Address</base-card-heading>
      </template>
      <div class="row">
        <div class="col-sm-6">
          <base-field label="Street Name">
            <base-input v-model="value.address.addressLine1" placeholder="street name" :readonly="readonly" />
          </base-field>
        </div>
        <div class="col-sm-6">
          <base-field label="Town/City">
            <base-input v-model="value.address.town" placeholder="town/city" :readonly="readonly" />
          </base-field>
        </div>
        <div class="col-sm-6">
          <base-field label="County">
            <base-input v-model="value.address.county" placeholder="county" :readonly="readonly" />
          </base-field>
        </div>
        <div class="col-sm-6">
          <base-field label="Postcode">
            <base-input v-model="value.address.postcode" placeholder="postcode" :readonly="readonly" />
          </base-field>
        </div>
      </div>
    </base-card>
    <base-card>
      <template v-slot:header>
        <base-card-heading>Overview</base-card-heading>
      </template>
      <wysiwyg-editor v-model="value.overview" />
    </base-card>
    <base-card>
      <template v-slot:header>
        <base-card-heading>Agent</base-card-heading>
      </template>
      <div class="row">
        <div class="col-sm-6">
          <base-field label="Agent Name">
            <base-input v-model="value.agent.name" placeholder="agent name" :readonly="readonly" />
          </base-field>
        </div>
        <div class="col-sm-6">
          <base-field label="Agent Number">
            <base-input v-model="value.agent.number" placeholder="agent number" :readonly="readonly" type="tel" />
          </base-field>
        </div>
        <div class="col-sm-6">
          <base-checkbox v-model="value.agent.canContact" :readonly="readonly">
            Can we contact the agent?
          </base-checkbox>
        </div>
      </div>
    </base-card>
    <base-card>
      <template v-slot:header>
        <base-card-heading>Planning Permission</base-card-heading>
      </template>
      <div class="row">
        <div class="col-12">
          <base-checkbox v-model="value.hasPlanningPermission" :readonly="readonly">
            Has the site got planning permission?
          </base-checkbox>
        </div>
        <div class="col-12 mb-4">
          <base-checkbox v-model="value.permissionWholeProject" :readonly="readonly">
            Does the planning cover the whole project?
          </base-checkbox>
        </div>
        <div class="col-12">
          <base-field label="Planning Details">
            <base-textarea
              v-model="value.planningDetails"
              disable-smart-placeholder
              placeholder="Please give details of any planning."
              :readonly="readonly" />
          </base-field>
        </div>
        <div class="col-12">
          <base-field label="Planning Permission Number(s)" tooltip="Separate each number with a comma (,).">
            <base-input v-model="value.planningNumbers" placeholder="planning number(s)" :readonly="readonly" />
          </base-field>
        </div>
      </div>
    </base-card>
    <supporting-documents :no-delete="readonly" />
  </div>
</template>

<script>
import SupportingDocuments from './SupportingDocuments.vue'
import WysiwygEditor from './WysiwygEditor.vue'

export default {
  name: 'ProjectDetails',

  components: {
    SupportingDocuments,
    WysiwygEditor
  },

  props: {
    readonly: { default: false, type: Boolean },
    value: { default: () => {}, type: Object }
  }
}
</script>
